import { useState } from 'react';

import { ImportType } from '../../../../../gql/generated/graphql';
import { frozenOrLockedCredit } from '../../../../../utils/tempInfo';
import { DealStateEnum } from '../../../../../utils/types/deal';
import { DealWithFarthestState } from '../../../utils';
import { CreditStatus, FROZEN_UI_STATES, OTHER_FAILURE_TYPES } from '../utils';

const useCreditStatus = (deal: DealWithFarthestState) => {
  const [isFrozenModalOpen, setIsFrozenModalOpen] = useState(false);

  const dealState = deal?.state as DealStateEnum;
  const isFrozenDealState = FROZEN_UI_STATES.includes(dealState);

  const isCreditFrozen =
    isFrozenDealState &&
    (frozenOrLockedCredit(deal?.customer?.prequalification?.prequalification_errors ?? []) ||
      frozenOrLockedCredit(deal?.cobuyer?.prequalification?.prequalification_errors ?? []));

  const creditStatus: CreditStatus = isCreditFrozen
    ? 'frozen'
    : OTHER_FAILURE_TYPES.includes(deal?.import_type as ImportType)
    ? 'otherFailure'
    : 'normal';

  return { creditStatus, isFrozenModalOpen, setIsFrozenModalOpen };
};

export default useCreditStatus;
